<template>
  <b-container
    fluid
    class="m-0 p-0 w-100 h-100"
  >
    <b-row
      ref="mainRow"
      class="w-100 viewer-row"
    >
      <ReportListSidebar
        ref="reportListSidebarComp"
        @reportSelected="onReportSelected"
        @projectDisabled="onProjectDisabled"
      />
      <ReportViewerContent
        ref="contentComp"
        :update-sidebar="updateSidebar"
      />
    </b-row>
  </b-container>
</template>

<script>
import ReportListSidebar from '../components/reportViewer/ReportListSidebar'
import ReportViewerContent from '../components/reportViewer/ReportViewerContent'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ReportViewer',
  components: {
    ReportListSidebar,
    ReportViewerContent,
  },
  computed: {
    ...mapGetters(['isReportModifiedReportViewer']),
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isReportModifiedReportViewer && to.name !== 'Terminal') {
      try {
        await this.$confirm(
          'You have changes to the report without saving. Do you want to discard them?',
          'Discard changes',
          'question',
          {
            confirmButtonText: 'Discard',
          }
        )
      } catch {
        return
      }
      this.setForceReadFromDBReportViewer(true)
    }
    next();
  },
  methods: {
    ...mapActions(['setForceReadFromDBReportViewer']),
    onReportSelected() {
      this.$refs.contentComp.reportSelectedSidebar()
    },
    onProjectDisabled() {
      this.$refs.contentComp.projectDisabled()
    },
    async updateSidebar() {
      await this.$refs.reportListSidebarComp.updateTableReports()
    },
  },
}
</script>

<style lang="scss" scoped>
.viewer-row {
  overflow: hidden;
  flex-wrap: nowrap;
  height: 92vh; // matches .main_content height in App.vue
}

::v-deep #reports-sidebar {
  left: 6% !important;
  top: 12vh;
  height: 80vh !important;
  background-color: #EEE !important;
}
</style>
